import { render, staticRenderFns } from "./BeeDropZone.vue?vue&type=template&id=63b951f2&"
import script from "./BeeDropZone.vue?vue&type=script&lang=js&"
export * from "./BeeDropZone.vue?vue&type=script&lang=js&"
import style0 from "./BeeDropZone.vue?vue&type=style&index=0&id=63b951f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports